/*
 * Purpose : common component to display daughnut chart
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from "react";
import { Doughnut } from "react-chartjs-2";
import { MDBContainer } from "mdbreact";

import {toolStatusChartLabels, toolStatusChartLabelColors, toolStatusChartLabelHoverColors} from '../../config/constants';

const DaughnutChart = (props) => {
  const dataDoughnut = {
    labels: toolStatusChartLabels,//["Approved", "Waiting for approval", "Rejected"],
    datasets: [
      {
        data: props.dataArr,//[60, 30, 10],
        backgroundColor: toolStatusChartLabelColors,//["#00ff4b", "#ffff3d", "#ff4c00"],
        hoverBackgroundColor: toolStatusChartLabelHoverColors//["#00ff8e", "#ffff78", "#ff4c3f"]
      }
    ]
  }
  return (
    <div style={{display:"-webkit-inline-box" }}>
      <MDBContainer>
        {/* <h3 className="mt-5">Tools By Status</h3> */}
        <Doughnut 
            //width={150}
            height={250}
            data={dataDoughnut} options={{ responsive: true, legend:{ display:true, position:'bottom'} }} />
      </MDBContainer>
    </div>
  );
}
export default DaughnutChart;